import { datePlusDays, generateShortCode } from "./lib/utils.js";

export class Booking {
  prices = {
    total: 0,
    prepayment: 0,
    payment_on_spot: 0,
    cancel_fee: 0,
    living: 0,
    first_day: 0,
    last_day: 0,
  };

  bookingData = {
    food: 0,
    hotel: null,
    room: null,
    tariff: null,
  };
  tariff = {};
  base = {
    id: "",
    terms_of_payment: "prepayment",
    terms_of_payment_prepaid_sum: 0,
    terms_of_payment_prepaid_target: "first_day",
    terms_of_payment_prepaid_type: 0,
    cancel_reservation_fee: "no",
    cancel_reservation_fee_time: "from_time",
    cancel_reservation_fee_amount: 0,
    cancel_reservation_fee_amount_type: 0,
    cancel_reservation_activation_time: 0,
    cancel_reservation_type: "prepaid",
    cancel_reservation_activation_time_type: 0,
    name: "",
    anounce: "",
    description: "",
  };
  conditions = {};

  defTariffs = []; // доп тарифы
  additionalTariffs = []; // накладывающиеся тарифы
  services = []; // товары и услуги

  selectedTariffs = [];
  selectedAdditionalTariffs = [];
  selectedServices = [];
  selectedServicesWithDates = [];
  selectedNumber = null;

  constructor(tariff, booking_data, setNeedRefresh) {
    this.refreshFunc = setNeedRefresh;
    this.bookingData = booking_data;
    this.tariff = tariff; // del base
    this.base = tariff.base; // del price
    this.conditions = tariff.base;
    if (booking_data.number != 0) {
      this.selectedNumber = booking_data.number;
    }
    this.calcPrices();
  }

  calcPrices() {
    if (!this.tariff?.prices?.[0]) {
      return false;
    }
    // базовый тариф
    this.prices.living = this.tariff.prices[0].total_cost;
    this.prices.total = this.prices.living;
    this.prices.first_day = this.tariff.prices[0].first_day_price;
    this.prices.last_day = this.tariff.prices[0].last_day_price;

    // наложение тарифов
    if (this.selectedAdditionalTariffs.length > 0) {
      this.selectedAdditionalTariffs.forEach((el) => {
        // применить скидку/наценку
        this.prices.total += el.price_sum;
      });
    }

    // предоплата
    this.prices.prepayment = this.prepayCalc(this.base, this.prices);
    // стоимость отмены
    this.prices.cancel_fee = this.cancelFeeCalc(this.base, this.prices);

    // доп тарифы
    if (this.selectedTariffs.length > 0) {
      this.selectedTariffs.forEach((el) => {
        // применить скидку/наценку
        this.prices.total += el.price_sum;
      });
    }

    // услуги и товары
    if (this.selectedServices.length > 0) {
      this.selectedServices.forEach((el) => {
        if (el?.calculated) {
          this.prices.total += el.sum;
          this.prices.prepayment += el.prepay;
          this.prices.cancel_fee += el.cancel_fee;
          return;
        }

        if (
          el.service_type == "service" &&
          el?.pay_type != "fixed" &&
          el?.service_is_personal_time == "2"
        ) {
          // нефиксированная оплата услуги
          if (el.pay_target == "service") {
            // оплата за услугу
            if (el.pay_type == "minute") {
              const minutes = el.duration / (+el?.service_count || 1);
              el.sum = Math.round(el.price * minutes);
              // Используем prepayCalc с базовым тарифом для услуг
              el.prepay = this.prepayCalcForService(el.sum);
              el.cancel_fee = this.cancelFeeCalcForService(el.sum, el.prepay);
            } else if (el.add_hour == 0) {
              // кратный период
              const hours = el.duration / 60 / (+el?.service_count || 1);
              el.sum = el.price * hours;
              // Используем prepayCalc с базовым тарифом для услуг
              el.prepay = this.prepayCalcForService(el.sum);
              el.cancel_fee = this.cancelFeeCalcForService(el.sum, el.prepay);
            } else {
              // период + доп часы
              const hours_duration = el.duration / 60;
              el.sum =
                el.price +
                (hours_duration - (+el?.service_count || 1)) *
                  (el?.add_hour_price || el.price);
              // Используем prepayCalc с базовым тарифом для услуг
              el.prepay = this.prepayCalcForService(el.sum);
              el.cancel_fee = this.cancelFeeCalcForService(el.sum, el.prepay);
            }
          } else if (el.pay_target == "guest") {
            // нефиксированная оплата за гостя
            el.sum = el.price;
            // Используем prepayCalc с базовым тарифом для услуг
            el.prepay = this.prepayCalcForService(el.sum);
            el.cancel_fee = this.cancelFeeCalcForService(el.sum, el.prepay);
          }
        } else {
          // фиксированная стоимость
          // Для фиксированных услуг также используем условия из базового тарифа
          // el.sum = el.price * el.count;
          // el.prepay = this.prepayCalcForService(el.sum);
          // el.cancel_fee = this.cancelFeeCalcForService(el.sum, el.prepay);

          // фиксированная стоимость
          el.sum = el.price * el.count;
          el.prepay = this.prepayCalcForService(el.sum); // это для одной единицы
          el.cancel_fee = this.cancelFeeCalcForService(el.sum, el.prepay);
          // ИСПРАВЛЕНО: умножаем на count
          el.prepay *= el.count;
          el.cancel_fee *= el.count;
        }

        el.calculated = true;
        this.prices.total += el.sum;
        this.prices.prepayment += el.prepay;
        this.prices.cancel_fee += el.cancel_fee;
      });
    }

    // оплата на месте
    this.prices.payment_on_spot = this.prices.total - this.prices.prepayment;

    this.setNeedRefresh();
  }

  addTariff = (tariff) => {
    if (tariff?.additional) {
      // если должен обновлять базовые условия оплаты и отмены
      if (
        tariff?.terms_of_payment &&
        tariff.active &&
        tariff?.terms_of_payment_crossing === "overwrite"
      ) {
        this.base = { ...this.base, ...tariff };
      } else {
        // вернуть базовые условия при смене тарифа
        this.base = this.conditions;
      }
      this.selectedAdditionalTariffs = tariff.active ? [tariff] : [];
    } else {
      const new_tariffs = this.selectedTariffs.filter(
        (p) => p.id !== tariff.id,
      );
      const new_state = tariff.active
        ? [...new_tariffs, tariff]
        : [...new_tariffs];
      this.selectedTariffs = new_state;
    }
    this.calcPrices();
  };

  addService = (service) => {
    const serv_for_add = { ...service };

    // Проверяем, нужно ли применять условия из базового тарифа
    const useBaseTariffConditions =
      serv_for_add?.terms_of_payment === "yes" ||
      serv_for_add?.cancel_reservation_fee === "yes";

    // если добавление - расчитать стоимости услуги
    if (serv_for_add.count) {
      if (!service?.date) {
        serv_for_add.sum = serv_for_add.count * serv_for_add.price;
      }

      // Рассчитываем предоплату и стоимость отмены
      if (useBaseTariffConditions) {
        // Используем условия из базового тарифа
        serv_for_add.prepay = this.prepayCalcForService(serv_for_add.sum);
        serv_for_add.cancel_fee = this.cancelFeeCalcForService(
          serv_for_add.sum,
          serv_for_add.prepay,
        );
      } else {
        // Используем собственные условия услуги (если они есть)
        serv_for_add.prepay = this.prepayCalc(serv_for_add, {
          total: serv_for_add.sum,
        });
        serv_for_add.cancel_fee = this.cancelFeeCalc(serv_for_add, {
          total: serv_for_add.sum,
          prepayment: serv_for_add.prepay,
        });
      }
    }

    // обновить массив услуг
    const new_services = this.selectedServices.filter(
      (p) => p.add_id !== service.add_id,
    );
    const new_state = serv_for_add.count
      ? [...new_services, serv_for_add]
      : [...new_services];
    this.selectedServices = new_state;

    this.calcPrices();

    if (service?.date) {
      // услуга с указанием даты и времени
      // добавляем в отдельный массив
      // если выходит за пределы дня - разделяем на две части
      if (serv_for_add.count) {
        const endHour =
          (service.hour * 60 +
            service.duration +
            service.minute +
            (service?.technical_break || 0)) /
          60;
        if (endHour >= 24) {
          // добавляем запись до 24 + остаток на следующую дату
          const first_duration = (24 - service.hour) * 60 - service.minute;
          this.selectedServicesWithDates = [
            ...this.selectedServicesWithDates,
            { ...serv_for_add, h_end: 24, m_end: 0, duration: first_duration },
            {
              ...serv_for_add,
              date: datePlusDays(service.date, 1),
              hour: 0,
              minute: 0,
              duration:
                service.duration -
                first_duration +
                (service?.technical_break || 0),
            },
          ];
        } else {
          // добавляем одну запись
          this.selectedServicesWithDates = [
            ...this.selectedServicesWithDates,
            {
              ...serv_for_add,
              duration: serv_for_add.duration + (service?.technical_break || 0),
            },
          ];
        }
      } else {
        // услуга удалена
        this.selectedServicesWithDates = this.selectedServicesWithDates.filter(
          (p) => p.add_id !== service.add_id,
        );
      }
    }
  };

  // Новый метод для расчета предоплаты услуги на основе базового тарифа
  prepayCalcForService = (serviceTotal) => {
    let final_prep_sum = 0;

    // Проверяем, что базовый тариф имеет условия предоплаты
    if (this.base?.terms_of_payment === "prepayment") {
      // Учитываем только если тип предоплаты - проценты (0)
      if (this.base?.terms_of_payment_prepaid_type === 0) {
        const prep_percent = this.base?.terms_of_payment_prepaid_sum || 0;
        final_prep_sum = Math.round((serviceTotal / 100) * prep_percent);
      }
      // Если рубли - не учитываем (final_prep_sum остается 0)
    }

    return final_prep_sum;
  };

  // Новый метод для расчета стоимости отмены услуги на основе базового тарифа
  cancelFeeCalcForService = (serviceTotal, servicePrepayment) => {
    let final_cancel_sum = 0;

    // Проверяем, что базовый тариф имеет условия отмены
    if (this.base?.cancel_reservation_fee === "yes") {
      // Учитываем только если тип штрафа - проценты (0)
      if (this.base?.cancel_reservation_fee_amount_type === 0) {
        const cancel_percent = this.base?.cancel_reservation_fee_amount || 0;
        final_cancel_sum = Math.round((serviceTotal / 100) * cancel_percent);
      }
      // Если рубли - не учитываем (final_cancel_sum остается 0)
    }

    return final_cancel_sum;
  };

  // Оригинальный метод prepayCalc - оставлен для обратной совместимости с тарифами
  prepayCalc = (tariff, prices) => {
    let final_prep_sum = 0;
    if (tariff?.terms_of_payment === "prepayment") {
      const prep_sum = tariff?.terms_of_payment_prepaid_sum || 0;
      if (tariff?.terms_of_payment_prepaid_type === 1) {
        // rub
        final_prep_sum = prep_sum;
      } else {
        // %
        if (tariff?.terms_of_payment_prepaid_target === "booking") {
          // от стоимости бронирования
          final_prep_sum = Math.round((prices.total / 100) * prep_sum);
        } else if (tariff?.terms_of_payment_prepaid_target === "first_day") {
          // от первых суток
          final_prep_sum = Math.round((prices.first_day / 100) * prep_sum);
        } else {
          final_prep_sum = Math.round((prices.total / 100) * prep_sum);
        }
      }
    }
    return final_prep_sum;
  };

  // Оригинальный метод cancelFeeCalc - оставлен для обратной совместимости с тарифами
  cancelFeeCalc = (tariff, prices) => {
    let final_cancel_sum = 0;
    if (tariff?.cancel_reservation_fee === "yes") {
      const cancel_sum = tariff?.cancel_reservation_fee_amount || 0;
      if (tariff?.cancel_reservation_fee_amount_type === 1) {
        // rub
        final_cancel_sum = cancel_sum;
      } else {
        // %
        if (tariff?.cancel_reservation_type === "prepaid") {
          // от суммы предоплаты
          final_cancel_sum = Math.round((prices.prepayment / 100) * cancel_sum);
        } else if (tariff?.cancel_reservation_type === "booking") {
          //  от стоимости бронирования
          final_cancel_sum = Math.round((prices.total / 100) * cancel_sum);
        } else if (tariff?.cancel_reservation_type === "first_day") {
          // стоимости первых суток
          final_cancel_sum = Math.round((prices.first_day / 100) * cancel_sum);
        }
      }
    }
    return final_cancel_sum;
  };

  setNeedRefresh() {
    this.refreshFunc((prev) => prev + 1);
  }

  setSelectedNumber = (number) => {
    this.selectedNumber = number;
    this.setNeedRefresh();
  };

  // получить дополнительный id услуги
  // для добавления нескольких одинаковых услуг с временем
  getAddId = (service) => {
    if (service?.service_is_personal_time == 2) {
      return generateShortCode(10);
    }
    return service._id;
  };
}
